import {useState} from "react";
import {useNavigate} from "react-router-dom";
import GatePassConfigurationService from "../services/api/gatepass-configuration";
import {useSnackbar} from "notistack";
import useGatePassConfigurationStore from "../zustand/useGatePassConfigurationStore";


const useGatePassConfiguration = () => {
    const {enqueueSnackbar} = useSnackbar();
    const navigate = useNavigate();

    const {setGatePassConfigurationStatusUpdated, setGatePassConfigurationDeleted} = useGatePassConfigurationStore();

    const [isFetchingGatePassConfigurationList, setFetchingGatePassConfigurationList] = useState(false);
    const [gatePassConfigurationListData, setGatePassConfigurationListData] = useState([]);
    const [isAddingGatePassConfiguration, setAddingGatePassConfiguration] = useState(false);
    const [isViewingGatePassConfiguration, setViewingGatePassConfiguration] = useState(false);
    const [gatePassConfigurationDetails, setGatePassConfigurationDetails] = useState(null);
    const [isUpdatingGatePassConfigurationStatus, setUpdatingGatePassConfigurationStatus] = useState(false);
    const [isDeletingGatePassConfiguration, setDeletingGatePassConfiguration] = useState(false);
    const [isUpdatingGatePassConfiguration, setUpdatingGatePassConfiguration] = useState(false);


    const listProfileGatePassConfiguration = (parameters) => {
        setFetchingGatePassConfigurationList(true);   
        setGatePassConfigurationStatusUpdated(false);
        setGatePassConfigurationDeleted(false);

        GatePassConfigurationService.listProfileGatePassConfiguration(parameters).then((res) => {
            console.log("listGatePassConfiguration data xxxx", res);

            if (res.data.success) {
                setFetchingGatePassConfigurationList(false);
                setGatePassConfigurationListData(res.data.data);
            } 

        }).catch((error) => {
            console.error("Error fetching profile gatepass configuration list:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassConfigurationListData([]);
            setFetchingGatePassConfigurationList(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const createProfileGatePassConfiguration = (payload, setOpen) => {
        setAddingGatePassConfiguration(true);

        GatePassConfigurationService.createProfileGatePassConfiguration(payload).then((res) => {
            console.log("createProfileGatePassConfiguration data xxxx", res);

            if (res.data.success) {
                setAddingGatePassConfiguration(false);
                setOpen(false);
                enqueueSnackbar("Successfully added profile gate pass configuration", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                navigate(`/rbac/gatepass-configuration/view?role=${res.data?.data?.data?.role}&id=${res.data?.data?.data?.profile_gatepass_type_uid}`);
            }

        }).catch((error) => {
            console.error("Error creating profile gate pass configuration:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setAddingGatePassConfiguration(false);
            setOpen(true);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }

    const viewProfileGatePassConfiguration = (parameters) => {
        setViewingGatePassConfiguration(true);

        GatePassConfigurationService.viewProfileGatePassConfiguration(parameters).then((res) => {
            console.log("viewProfileGatePassConfiguration data xxxx", res);

            if (res.data.success) {
                setViewingGatePassConfiguration(false);
                setGatePassConfigurationDetails(res.data.data);
            }

        }).catch((error) => {
            console.error("Error fetching profile gatepass configuration details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassConfigurationDetails(null);
            setViewingGatePassConfiguration(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateProfileGatePassConfigurationStatus  = (parameters) => {
        setUpdatingGatePassConfigurationStatus(true);

        GatePassConfigurationService.updateProfileGatePassConfigurationStatus(parameters).then((res) => {
            console.log("updateGatePassConfigurationStatus data xxxx", res);

            if (res.data.success) {
                setUpdatingGatePassConfigurationStatus(false);
                setGatePassConfigurationStatusUpdated(true);

                enqueueSnackbar("Successfully updated profile gate pass configuration status", {
                    variant: "success",
                    autoHideDuration: 3500
                })
            } 

        }).catch((error) => {
            console.error("Error updating profile gate pass configuration status:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassConfigurationStatusUpdated(false);
            setUpdatingGatePassConfigurationStatus(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const deleteProfileGatePassConfiguration  = (parameters) => {
        setDeletingGatePassConfiguration(true);

        GatePassConfigurationService.deleteProfileGatePassConfiguration(parameters).then((res) => {
            console.log("deleteProfileGatePassConfiguration data xxxx", res);

            if (res.data.success) {
                setDeletingGatePassConfiguration(false);
                setGatePassConfigurationDeleted(true);

                enqueueSnackbar("Successfully deleted profile gate pass configuration", {
                    variant: "success",
                    autoHideDuration: 3500
                })
            } 

        }).catch((error) => {
            console.error("Error deleting profile gate pass configuration:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setGatePassConfigurationDeleted(false);
            setDeletingGatePassConfiguration(false);
            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })
    }

    const updateProfileGatePassConfigurationDetails = (parameters, setOpen) => {
        setUpdatingGatePassConfiguration(true);

        GatePassConfigurationService.updateProfileGatePassConfigurationDetails(parameters).then((res) => {
            console.log("updateProfileGatePassConfigurationDetails data xxxx", res);

            if (res.data.success) {
                setUpdatingGatePassConfiguration(false);
                setOpen(false);

                enqueueSnackbar("Successfully updated profile gate pass configuration", {
                    variant: "success",
                    autoHideDuration: 3500
                });

                navigate(`/rbac/gatepass-configuration/view?role=${res.data?.data?.role}&id=${res.data?.data?.profile_gatepass_type_uid}`);
            }

        }).catch((error) => {
            console.error("Error updating profile gate pass configuration details:", error);
            const errorMessage = error?.response?.data?.error || error.message;

            setUpdatingGatePassConfiguration(false);
            setOpen(true);

            enqueueSnackbar(errorMessage, {
                variant: "error",
                autoHideDuration: 4000
            })
        })   
    }
    
    
    return {
        isFetchingGatePassConfigurationList,
        gatePassConfigurationListData,
        listProfileGatePassConfiguration,

        isAddingGatePassConfiguration,
        createProfileGatePassConfiguration,
        
        isViewingGatePassConfiguration,
        gatePassConfigurationDetails,
        viewProfileGatePassConfiguration,

        isUpdatingGatePassConfigurationStatus,
        updateProfileGatePassConfigurationStatus,

        isDeletingGatePassConfiguration,
        deleteProfileGatePassConfiguration,

        isUpdatingGatePassConfiguration,
        updateProfileGatePassConfigurationDetails
    }
}

export default useGatePassConfiguration
